module.exports = __webpack_public_path__ + "static/లా లోచనం-6a0087e36abe1c73b13a1e886e75cb45.jpg";